import { IntegratedFormQuery } from '../integrated-form-context';

export function mergeQueries(...queries: IntegratedFormQuery[]): IntegratedFormQuery {
    return queries
        .map((query) => ({
            isInitialLoading: query.isInitialLoading,
            isError: query.isError,
        }))
        .reduce((acc, val) => ({
            isInitialLoading: acc.isInitialLoading || val.isInitialLoading,
            isError: acc.isError || val.isError,
        }));
}
